<mat-card-header>
  <mat-card-title>
    {{data.title}}
  </mat-card-title>
</mat-card-header>
<mat-card-content>
  {{data.body}}
</mat-card-content>
<mat-card-footer style="margin-top: 20px; display: block;">
  <button mat-raised-button (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="warn" (click)="confirm()" style="float: right;">
    Löschen
  </button>
</mat-card-footer>
